"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChatButtonVisible = exports.setHiddenState = exports.initChatCustom = exports.initChat = void 0;
var utils_1 = require("./utils");
function initChat() {
    if (!document.querySelector('.js-chat-lcw-start'))
        return;
    var chatbotButton = document.querySelector('.js-chat-lcw-start');
    init(chatbotButton, function () {
        var _a, _b, _c;
        var openChat = function () {
            Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
        };
        if (document.querySelector('#Microsoft_Omnichannel_LCWidget')) {
            openChat();
        }
        else {
            var scriptElement = document.createElement('script');
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.src = 'https://oc-cdn-public-eur.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js';
            scriptElement.id = 'Microsoft_Omnichannel_LCWidget';
            scriptElement.dataset.appId = (_a = chatbotButton.dataset.appId) !== null && _a !== void 0 ? _a : '8a73df4a-65e6-4ad6-9d48-65ea0a096c1d';
            scriptElement.dataset.orgId = (_b = chatbotButton.dataset.orgId) !== null && _b !== void 0 ? _b : '99f9ea5c-45cf-4bf3-94e9-7e34c9fa8d69';
            scriptElement.dataset.orgUrl = (_c = chatbotButton.dataset.orgUrl) !== null && _c !== void 0 ? _c : 'https://org5563f30c-crm4.omnichannelengagementhub.com';
            if (chatbotButton.dataset.lcwVersion)
                scriptElement.dataset.lcwVersion = chatbotButton.dataset.lcwVersion;
            // scriptElement.dataset.suggestedActionLayout = 'stacked'; // If this is activated, color does not work anymore for suggested actions
            scriptElement.dataset.colorOverride = '#e2002a';
            scriptElement.dataset.fontFamilyOverride = 'Arial, Helvetica, sans-serif';
            // scriptElement.dataset.hideChatButton = 'true'; // Leaves hidden IFrame and makes areas behind unclickable
            document.body.appendChild(scriptElement);
            var chatbotButtonTextContent_1 = chatbotButton.querySelector('span').textContent;
            chatbotButton.querySelector('span').textContent = chatbotButton.dataset.loadingMessage;
            window.addEventListener('lcw:ready', function () {
                chatbotButton.querySelector('span').textContent = chatbotButtonTextContent_1;
                chatbotButton.style.display = 'none';
                openChat();
            });
        }
    });
}
exports.initChat = initChat;
function initChatCustom() {
    if (!document.querySelector('.js-chat-lcw-custom-start'))
        return;
    var chatbotButton = document.querySelector('.js-chat-lcw-custom-start');
    var root = document.createElement('div');
    root.id = 'oebb-live-chat-widget';
    root.dataset.orgId = chatbotButton.dataset.orgId; // '99f9ea5c-45cf-4bf3-94e9-7e34c9fa8d69';
    root.dataset.orgUrl = chatbotButton.dataset.orgUrl; // 'https://org5563f30c-crm4.omnichannelengagementhub.com';
    root.dataset.widgetId = chatbotButton.dataset.appId; // '2c783452-d4ac-45d2-9a3f-1a5749c04f93';
    document.body.appendChild(root); // Append to body, to better prevent style conflicts
    init(chatbotButton, function () {
        var chatbotButtonTextContent = chatbotButton.querySelector('span').textContent;
        chatbotButton.querySelector('span').textContent = chatbotButton.dataset.loadingMessage;
        (0, utils_1.loadScript)((0, utils_1.getResourceUrl)('js/main-chat-lcw.min.js'));
        window.addEventListener('oebb:lcw:ready', function () {
            chatbotButton.querySelector('span').textContent = chatbotButtonTextContent;
            chatbotButton.style.display = 'none';
        });
    });
}
exports.initChatCustom = initChatCustom;
function setHiddenState(element) {
    setTimeout(function () {
        if (element.classList.contains('chat-dsgvo-popup--visible'))
            return;
        element.hidden = true;
    }, 1000);
}
exports.setHiddenState = setHiddenState;
function isChatButtonVisible(fromHours, toHours) {
    var from = new Date(new Date().getFullYear(), (3 - 1), 29); // Start of DST in Europe: 29.03.
    var to = new Date(new Date().getFullYear(), (10 - 1), 25); // End of DST in Europe 25.10.
    var now = new Date();
    var offset = '+1';
    if (now >= from && now <= to)
        offset = '+2';
    var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    var viennaHours = new Date(utc + (3600000 * offset)).getHours();
    if (viennaHours >= fromHours && viennaHours < toHours)
        return true;
    return false;
}
exports.isChatButtonVisible = isChatButtonVisible;
function init(button, loaderFn) {
    var skipLinks = document.querySelector('.skip-links');
    if (skipLinks) {
        var link = document.createElement('a');
        link.href = "#".concat(button.getAttribute('id'));
        link.className = 'screen-reader-text';
        link.accessKey = '2';
        link.textContent = "".concat(button.dataset.skipLinkMessage, " (Alt+2)");
        skipLinks.appendChild(link);
    }
    if (!isChatButtonVisible(button.dataset.availableFrom ? parseInt(button.dataset.availableFrom) : 0, button.dataset.availableTo ? parseInt(button.dataset.availableTo) : 24)) {
        var offlineTitle = document.createElement('span');
        offlineTitle.classList.add('chat-wc-button__caption-offline');
        offlineTitle.textContent = button.dataset.offlineTitle;
        button.querySelector('.js-chat-wc-button-caption').appendChild(offlineTitle);
        button.insertAdjacentHTML('afterend', "\n            <div class=\"chat-wc-offline-message js-chat-wc-offline-message\">\n                <button class=\"js-chat-wc-offline-message-close\">\n                    <span class=\"ic-close\" aria-hidden=\"true\"></span>\n                    <span class=\"screen-reader-text\">".concat(button.dataset.closeMessage, "</span>\n                </button>\n                <p>").concat(button.dataset.offlineMessage, "</p>\n            </div>\n        "));
        button.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.js-chat-wc-offline-message').classList.add('chat-wc-offline-message--open');
        });
        document.querySelector('.js-chat-wc-offline-message-close').addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.js-chat-wc-offline-message').classList.remove('chat-wc-offline-message--open');
        });
        return;
    }
    var dsgvoDisclaimer = document.querySelector('.js-chat-dsgvo-disclaimer');
    var chatbotAlternative = document.querySelector('.js-chat-dsgvo-alternative');
    var disclaimerCloseBtn = document.querySelector('.js-btn-close-disclaimer');
    var alternativeCloseBtn = document.querySelector('.js-btn-close-alternative');
    var dsgvoConfirmButton = document.querySelector('.js-chat-dsgvo-confirm');
    var dsgvoCancleButton = document.querySelector('.js-chat-dsgvo-cancel');
    button.addEventListener('click', function (e) {
        e.preventDefault();
        dsgvoDisclaimer.hidden = false;
        setTimeout(function () { return dsgvoDisclaimer.classList.add('chat-dsgvo-popup--visible'); }); // Timeout to wait for "hidden" attribute
        disclaimerCloseBtn.focus();
    });
    disclaimerCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        this.parentElement.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        button.focus();
    });
    alternativeCloseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        this.parentElement.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(chatbotAlternative);
        button.focus();
    });
    dsgvoConfirmButton.addEventListener('click', function (e) {
        e.preventDefault();
        dsgvoDisclaimer.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        loaderFn();
    });
    dsgvoCancleButton.addEventListener('click', function (e) {
        e.preventDefault();
        dsgvoDisclaimer.classList.remove('chat-dsgvo-popup--visible');
        setHiddenState(dsgvoDisclaimer);
        chatbotAlternative.hidden = false;
        setTimeout(function () { return chatbotAlternative.classList.add('chat-dsgvo-popup--visible'); }); // Timeout to wait for "hidden" attribute
        alternativeCloseBtn.focus();
        if (document.querySelector('#Microsoft_Omnichannel_LCWidget')) {
            document.querySelector('#Microsoft_Omnichannel_LCWidget').remove();
            document.querySelector('#Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window').remove();
        }
    });
    if (button.dataset.textMobileFadeOut) {
        (0, utils_1.onScrollInterval)(function (latestScrollY, clearScrollInterval) {
            if (latestScrollY > 300) {
                clearScrollInterval();
                button.classList.add('chat-wc-button--text-mobile-fade-out');
            }
        });
    }
}
